import { Box } from '@mui/material';
import { FC } from 'react';

import { observer } from 'mobx-react-lite';
import { UserData } from '@codefluegel/wowis-rest-typescript-client';
import CardContainer from '../../components/cards/CardContainer';
import useMedia from '../../hooks/useMedia';
import IBANTextFieldListForm from '../../components/forms/IBANTextFieldListForm';

interface Props {
  user: UserData | undefined;
}

const PaymentData: FC<Props> = observer(props => {
  const { user } = props;
  const isMobile = useMedia('md');

  const title = 'Zahlungsdaten';

  return (
    <Box height={1} width={1} p={1}>
      <CardContainer
        title={title}
        customStyle={{
          sx: {
            margin: 0,
            marginBottom: isMobile ? 2 : 0,
          },
        }}
        iconOn
        iconName={title}
      >
        <Box
          sx={{
            width: 1,
            height: isMobile ? 1 : 'auto',
            minHeight: isMobile ? 1 : '15vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box
            width={1}
            overflow={isMobile ? 'none' : 'auto'}
            paddingX={4}
            display="flex"
            alignItems="center"
            my={1}
            justifyContent="center"
            alignContent="center"
          >
            {user?.customerId && (
              <IBANTextFieldListForm topUserId={user?.customerId} />
            )}
          </Box>
        </Box>
      </CardContainer>
    </Box>
  );
});

export default PaymentData;
